export enum UserRoleEnum {
  Installer = 'installer',
  AppAdmin = 'app_admin',
  SuperAdmin = 'super_admin',
  CountryAdmin = 'country_admin',
  SalesManagement = 'sales_management',
  SalesDirector = 'sales_director',
  RegionalManager = 'regional_manager',
}
